<div
	#tablearea
	class="tablearea">

	<div
		class="row"
		*ngIf="loading">
		<div class="icon-loading">
			<span>
				<i class="fa fa-circle-notch fa-spin fa-2x"></i>
			</span>

		</div>
	</div>

	<div class="row">
		<div class="col">
			<a
				class="float-right btn btn-sm btn-primary"
				(click)="add()"
				*ngIf="project?.isDraft">
				<i
					container="body"
					ngbTooltip="{{'labels.add-building' | translate}}"
					class="feather icon-plus"></i>
			</a>
		</div>
	</div>

	<div
		class="row"
		*ngIf="!loading && !buildings?.length">
		<div class="col text-center  p-5">{{'labels.no-buildings' | translate}}</div>
	</div>

	<div
		class="row"
		*ngIf="!loading && !objectives?.length">
		<div class="col text-center  p-5">
			{{'labels.no-objectives' | translate}}
			<a
				routerLink="/company/project/view/{{this.projectid}}"
				fragment="obiettivi">
				{{'labels.objective-create' | translate}}
			</a>
		</div>
	</div>

	<div
		class="row"
		*ngIf="!loading && objectives?.length && !activities">
		<div class="col text-center  p-5">
			{{'labels.no-activities' | translate}}
			<a
				routerLink="/company/project/view/{{this.projectid}}"
				fragment="obiettivi">
				{{'labels.activity-create' | translate}}
			</a>
		</div>
	</div>

	<div
		class="row"
		*ngIf="!loading && objectives &&  objectives.length && buildings && buildings.length && activities">
		<div class="col-sm-12">
			<a
				class="fullscreen-pointer"
				(click)="toggleFullscreen()">

				<i
					ngbTooltip="fullscreen"
					class="fas fa-{{tablefull ? 'compress' : 'expand'}}-arrows-alt"></i>

			</a>
			<table class="table-matrix fullscreen-table">
				<thead>
					<tr>
						<th class="no-border"></th>
						<ng-template
							ngFor
							let-obj
							[ngForOf]="objectives">

							<th
								class="rotate"
								*ngFor="let a of obj.activities">

								<div>
									<span>{{a.name | truncate:35}}</span>
									<!-- tronca al numero di caratteri passati e aggiunge ... -->
								</div>
							</th>

						</ng-template>
					</tr>
					<tr>
						<th class="no-border"></th>
						<ng-template
							ngFor
							let-obj
							[ngForOf]="objectives">
							<ng-template [ngIf]="obj.activities && obj.activities.length">
								<th
									class="objective-label"
									[attr.colspan]="obj.activities.length">
									{{obj.name}}
								</th>
							</ng-template>
						</ng-template>
					</tr>

				</thead>
				<tbody>
					<tr *ngFor="let r of buildings">
						<td class="names">{{r.name}}</td>
						<ng-template
							ngFor
							let-obj
							[ngForOf]="objectives">
							<td
								[ngClass]="{'active' : r.projectactivitiesmatrix[a.id]!== undefined}"
								class="checkbox"
								*ngFor="let a of obj.activities"
								(click)="toggle(a,r)">
								<span [ngbTooltip]="tooltip"></span>
								<ng-template #tooltip>
									{{ (r.projectactivitiesmatrix[a.id] == undefined ? 'labels.addbuilding' : 'labels.removebuilding') | translate:{building: r.name, activity:a.name} }}
								</ng-template>
							</td>
						</ng-template>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
